import { datadogLogs } from '@datadog/browser-logs';
import { app } from '@microsoft/teams-js';

import { userAuthStore } from '../modules/onboarding/stores/userAuthStore';

export async function initializeMSTeamsContext() {
  try {
    await app.initialize();
    const msTeamsContext = await app.getContext();
    userAuthStore.getState().setMSTeamsContext(msTeamsContext.user?.loginHint);
  } catch (error) {
    datadogLogs.logger.log('Unable to get user context for teams client', {
      error,
    });
  }
}
